import { Box, Button, Dialog as MUIDialog, styled, TextField } from '@mui/material';

import { theme } from 'styles';

export const Dialog = styled(MUIDialog)(() => ({
  '.MuiDialog-paper': {
    maxWidth: 'none',
    width: '564px',
    height: 'fit-content',
    padding: '24px',
    borderRadius: '12px',
    boxShadow: '0px 8px 32px rgba(0,0,0,0.12)',
    background: theme.palette.white.main,
  },
  '.MuiBackdrop-root': {
    background: 'rgba(0,0,0,0.2)',
    backdropFilter: 'blur(4px)',
  },
}));

export const SearchField = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    background: theme.palette.white.main,
    fontSize: '14px',
    height: '44px',
    border: `1px solid ${theme.palette.primary.grey}`,
    boxShadow: 'none',
    '&:hover': { border: `1px solid ${theme.palette.primary.grey}` },
    '&.Mui-focused': { border: `1px solid ${theme.palette.info.main}` },
  },
  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '& .MuiInputBase-input': {
    padding: '0 8px',
    fontSize: '14px',
  },
}));

export const UserListBox = styled(Box)(() => ({
  border: `1px solid ${theme.palette.primary.grey}`,
  borderRadius: '8px',
  overflow: 'hidden',
  marginTop: '12px',
  maxHeight: '260px',
  overflowY: 'auto',
}));

export const UserRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  gap: '12px',
  cursor: 'pointer',
  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.primary.grey}`,
  },
}));

export const SectionLabel = styled(Box)(() => ({
  fontSize: '14px',
  fontWeight: 600,
  color: theme.palette.primary.grey,
  margin: '12px 0 8px',
}));

export const FooterActions = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  marginTop: '24px',
}));

export const CancelButton = styled(Button)(() => ({
  height: '44px',
  width: '150px',
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '10px 24px',
  color: theme.palette.secondary.dark,
  border: `1px solid ${theme.palette.primary.grey}`,
  backgroundColor: theme.palette.white.main,
}));

export const PrimaryButton = styled(Button)(() => ({
  height: '44px',
  width: '150px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '10px 24px',
  color: theme.palette.white.main,
  background: theme.palette.info.main,
  border: 'none',
}));

export const VisibilityRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 0',
  borderBottom: `1px solid ${theme.palette.primary.grey}`,
  marginBottom: '4px',
}));

export const BottomSheetHandle = styled(Box)(() => ({
  width: '36px',
  height: '4px',
  borderRadius: '2px',
  margin: '10px auto 16px',
}));
